import React from "react";
import { useStores } from "_common/hooks";
import { Link, useNavigate } from "react-router-dom";
import i18next from "i18next";
import { formatNumber } from "_common/utils/formatValue";

export default function RankTop({ item }) {
  const navigate = useNavigate();
  const {
    authStore: { questions },
  } = useStores();

  return (
    <div className="flex mt-2 p-2 bg-[#1c1c1e]  rounded ">
      <div className="">
        <div className="w-12 h-12 text-center text-[#fff]">
          <span>{item?.rank}</span>
        </div>
      </div>
      <div className="ml-4 w-full">
        <div className="mb-4 text-[#fff]">{item?.name}</div>
        <div className="w-full grid grid-cols-2">
          <div className="w-full flex flex-col text-[14px]">
            <span className="text-[#9ca3af] ">
              {i18next.t("profit_amount")} 7 {i18next.t("day")}
            </span>
            <span className="text-[#55af72] text-[14px]">
              {formatNumber(item?.profit, "0,0.00")}%
            </span>
          </div>
          <div className="w-full flex flex-col text-[14px]">
            <span className="text-[#9ca3af] ">
              {i18next.t("profit2")} 7 {i18next.t("day")}
            </span>
            <span className="text-[#fff] text-[14px]">
              {formatNumber(item?.amount, "0,0.00")}{" "}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
